import React, { useMemo } from 'react';
import SidebarMenu from './SidebarMenu';
import useMensajesNoLeidos from '../../../hooks/useMensajesNoLeidos';

const buildParticularAlumnoMenuItems = () => ([
  {
    id: 'panel',
    label: 'Mi espacio',
    icon: 'fas fa-user-graduate',
    path: '/particular/alumno-panel',
    state: { activeMenu: 'panel' }
  },
  {
    id: 'calendario',
    label: 'Calendario',
    icon: 'fas fa-calendar-alt',
    path: '/particular/alumno-panel',
    state: { activeMenu: 'calendario' },
    requiresCalendarAccess: true
  },
  {
    id: 'mensajes',
    label: 'Mensajes',
    icon: 'fas fa-envelope',
    path: '/mensajes',
    state: { scope: 'particulares' }
  }
]);

const ParticularAlumnoMenu = ({
  activeId,
  onNavigate,
  className = '',
  messageScope = 'particular'
}) => {
  const { count: mensajesNoLeidos } = useMensajesNoLeidos(true, { scope: messageScope });
  const items = useMemo(() => buildParticularAlumnoMenuItems().map((item) => (
    item.id === 'mensajes' ? { ...item, badge: mensajesNoLeidos } : item
  )), [mensajesNoLeidos]);

  return (
    <SidebarMenu
      items={items}
      activeId={activeId}
      onNavigate={onNavigate}
      className={className}
    />
  );
};

export { buildParticularAlumnoMenuItems };
export default ParticularAlumnoMenu;
